<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">Purpose Of Insurance</div>
		<case-form :schema="schemaPurpose" class="mb6" />

		<div class="fs4 fw7 lh125 mt6 mb2">Type of Business</div>
		<case-form :schema="schemaTypeOfBusiness" class="mb6" />

		<div class="fs4 fw7 lh125 mt6 mb2">General Data</div>
		<case-form :schema="schemaGeneralData" class="mb6" />

		<div class="fs4 fw7 lh125 mt6 mb2">Balance Sheet</div>

		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span cclass="fs4 fw7 lh125 mt6 mb2">Current Year</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaBalanceSheetCurrent" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span cclass="fs4 fw7 lh125 mt6 mb2">Last Year</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaBalanceSheetLastYear" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: `Name of Business`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessName`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessName`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessName`,
							dataType: "string"
						}
					}
				},
				{
					label: "Business Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0insuranceRelatedToBusinessAddress",
					props: {
						suggest: {
							typeIncludes: "insuranceRelatedToBusinessAddress"
						},
						createOptions: {
							type: "insuranceRelatedToBusinessAddress"
						}
					}
				},
				{
					label: `Current Mailing Address, If Different`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessMailingAddress`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessMailingAddress`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessMailingAddress`,
							dataType: "string"
						}
					}
				},
				{
					label: `Business Telephone`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessTelephoneNo`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessTelephoneNo`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessTelephoneNo`,
							dataType: "string"
						}
					}
				},
				{
					label: `Business Fax`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessFaxNo`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessFaxNo`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessFaxNo`,
							dataType: "string"
						}
					}
				},
				{
					label: `Nature of Business`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessNature`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessNature`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessNature`,
							dataType: "string"
						}
					}
				},
				{
					label: `Business Website Address`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessWebsiteAddress`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessWebsiteAddress`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessWebsiteAddress`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPurpose() {
			return [
				{
					label: `Key Person`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeKeyPerson`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeKeyPerson`
						},
						createOptions: {
							type: `hasPurposeKeyPerson`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Credit Coverage`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeCreditCoverage`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeCreditCoverage`
						},
						createOptions: {
							type: `hasPurposeCreditCoverage`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Deferred Compensation`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeDeferredCompensation`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeDeferredCompensation`
						},
						createOptions: {
							type: `hasPurposeDeferredCompensation`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Other`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeOther`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeOther`
						},
						createOptions: {
							type: `hasPurposeOther`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `If "Other", please specify:`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeOtherDetails`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeOtherDetails`
						},
						createOptions: {
							type: `hasPurposeOtherDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTypeOfBusiness() {
			return [
				{
					label: `Sole proprietorship`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeSoleProprietorship`,
					props: {
						suggest: {
							typeIncludes: `hasTypeSoleProprietorship`
						},
						createOptions: {
							type: `hasTypeSoleProprietorship`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Corporation`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeCorporation`,
					props: {
						suggest: {
							typeIncludes: `hasTypeCorporation`
						},
						createOptions: {
							type: `hasTypeCorporation`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `General`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeGeneral`,
					props: {
						suggest: {
							typeIncludes: `hasTypeGeneral`
						},
						createOptions: {
							type: `hasTypeGeneral`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Limited`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeLimited`,
					props: {
						suggest: {
							typeIncludes: `hasTypeLimited`
						},
						createOptions: {
							type: `hasTypeLimited`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Limited Liability Company`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeLLC`,
					props: {
						suggest: {
							typeIncludes: `hasTypeLLC`
						},
						createOptions: {
							type: `hasTypeLLC`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Partnership`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypePartnership`,
					props: {
						suggest: {
							typeIncludes: `hasTypePartnership`
						},
						createOptions: {
							type: `hasTypePartnership`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaGeneralData() {
			return [
				{
					label: `Client's Position in the Company`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessPosition`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessPosition`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessPosition`,
							dataType: "string"
						}
					}
				},
				{
					label: `Salary (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessSalary`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessSalary`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessSalary`,
							dataType: "number"
						}
					}
				},
				{
					label: `Length of Service`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessLengthOfService`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessLengthOfService`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessLengthOfService`,
							dataType: "string"
						}
					}
				},
				{
					label: `Bonus (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessBonus`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessBonus`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessBonus`,
							dataType: "number"
						}
					}
				},
				{
					label: `Client's Ownership Share of the Business`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessOwnership`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessOwnership`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessOwnership`,
							dataType: "number"
						}
					}
				},
				{
					label: `Are other key employees to be insured?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0areOtherKeyEmployeesInsured`,
					props: {
						suggest: {
							typeIncludes: `areOtherKeyEmployeesInsured`
						},
						createOptions: {
							type: `areOtherKeyEmployeesInsured`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Details`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherKeyEmployeesInsuredDetails`,
					props: {
						suggest: {
							typeIncludes: `otherKeyEmployeesInsuredDetails`
						},
						createOptions: {
							type: `otherKeyEmployeesInsuredDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: `Have you ever declared bankruptcy?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDeclaredForBankruptcy`,
					props: {
						suggest: {
							typeIncludes: `hasDeclaredForBankruptcy`
						},
						createOptions: {
							type: `hasDeclaredForBankruptcy`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaBalanceSheetCurrent() {
			return [
				{
					label: `Assets (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementAssets`,
					props: {
						suggest: {
							typeIncludes: `financialStatementAssets`
						},
						createOptions: {
							type: `financialStatementAssets`,
							dataType: "number"
						}
					}
				},
				{
					label: `Net Worth (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementNetWorth`,
					props: {
						suggest: {
							typeIncludes: `financialStatementNetWorth`
						},
						createOptions: {
							type: `financialStatementNetWorth`,
							dataType: "number"
						}
					}
				},
				{
					label: `Gross Income (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementGrossIncome`,
					props: {
						suggest: {
							typeIncludes: `financialStatementGrossIncome`
						},
						createOptions: {
							type: `financialStatementGrossIncome`,
							dataType: "number"
						}
					}
				},
				{
					label: `Liabilities (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementLiabilities`,
					props: {
						suggest: {
							typeIncludes: `financialStatementLiabilities`
						},
						createOptions: {
							type: `financialStatementLiabilities`,
							dataType: "number"
						}
					}
				},
				{
					label: `Market Value (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementMarketValue`,
					props: {
						suggest: {
							typeIncludes: `financialStatementMarketValue`
						},
						createOptions: {
							type: `financialStatementMarketValue`,
							dataType: "number"
						}
					}
				},
				{
					label: `Net Income (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementNetIncome`,
					props: {
						suggest: {
							typeIncludes: `financialStatementNetIncome`
						},
						createOptions: {
							type: `financialStatementNetIncome`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaBalanceSheetLastYear() {
			return [
				{
					label: `Assets (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementAssetsLastYear`,
					props: {
						suggest: {
							typeIncludes: `financialStatementAssetsLastYear`
						},
						createOptions: {
							type: `financialStatementAssetsLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Net Worth (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementNetWorthLastYear`,
					props: {
						suggest: {
							typeIncludes: `financialStatementNetWorthLastYear`
						},
						createOptions: {
							type: `financialStatementNetWorthLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Gross Income (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementGrossIncomeLastYear`,
					props: {
						suggest: {
							typeIncludes: `financialStatementGrossIncomeLastYear`
						},
						createOptions: {
							type: `financialStatementGrossIncomeLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Liabilities (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementLiabilitiesLastYear`,
					props: {
						suggest: {
							typeIncludes: `financialStatementLiabilitiesLastYear`
						},
						createOptions: {
							type: `financialStatementLiabilitiesLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Market Value (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementMarketValueLastYear`,
					props: {
						suggest: {
							typeIncludes: `financialStatementMarketValueLastYear`
						},
						createOptions: {
							type: `financialStatementMarketValueLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Net Income (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementNetIncomeLastYear`,
					props: {
						suggest: {
							typeIncludes: `financialStatementNetIncomeLastYear`
						},
						createOptions: {
							type: `financialStatementNetIncomeLastYear`,
							dataType: "number"
						}
					}
				}
			]
		}
	}
}
</script>
